import {inlineError, tracer} from '@s-ui/decorators'
import {UseCase} from '@s-ui/domain'

export class GetSeoDataUseCase extends UseCase {
  /**
   * @constructor
   * @param {Object} deps
   * @param {Object} deps.config
   * @param {GetSeoDataService} deps.getSeoDataService
   * @param {Function} deps.seoDataRequestFactory
   * */
  constructor({config, getSeoDataService, seoDataRequestFactory}) {
    super()

    this._config = config
    this._getSeoDataService = getSeoDataService
    this._seoDataRequestFactory = seoDataRequestFactory
  }

  /**
   * @param {Object} param
   * @param {String} param.culture
   * @param {String} param.pageName
   * @param {Object} param.params
   * @return {Promise<[error, data], Error>}
   **/
  @tracer({metric: 'GetSeoDataUseCase#execute'})
  @inlineError
  async execute({culture, pageName, params, preloadImages} = {}) {
    const seoDataRequestVO = this._seoDataRequestFactory({
      culture,
      pageName,
      params,
      preloadImages
    })

    return this._getSeoDataService.execute({seoDataRequestVO}).then(function ([error, response]) {
      if (error) {
        return Promise.reject(error)
      }

      // We will check `isObjectDomain` until we refactor all the TechDebt in SEO context
      const isObjectDomain = 'toJSON' in response
      return isObjectDomain ? response.toJSON() : response
    })
  }
}
